/*
 *
 * Api reducer
 *
 */

import produce from 'immer';

import { REQUEST_EMAIL_HISTORY, REQUEST_EMAIL_HISTORY_FILTER } from './constants';

export const initialState = {
  emails: [],
  filter: {
    searchString: null,
    offset: 0,
  },
  emailsCount: null,
};

export const emailsHistoryReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.id) {
      case REQUEST_EMAIL_HISTORY:
        if (action.result) {
          draft.emails = action.result?.items;
          draft.emailsCount = action.result?.paginator.itemsCount;
        }
        break;
    }
    switch (action.type) {
      case REQUEST_EMAIL_HISTORY_FILTER:
        if (action.name) {
          draft.filter[action.name] = action.value;

          if (action.name !== 'offset') draft.filter.offset = 0;
        }
        break;
    }
  });
